import CheckboxGroup from './components/CheckboxGroup';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'checkBoxGroup',
  pluginComponent: CheckboxGroup,
});
